import { useMemo } from 'react'
import { useLanguage } from '../contexts/LanguageContext'
import { translations } from './translations'

export function useT() {
  const { lang } = useLanguage()
  return useMemo(() => translations[lang], [lang])
}
